var map = {
	"./AERIS-v0.2.json": 1157,
	"./BREEZE-v1.1.json": 6492,
	"./BREEZE-v2.1.json": 6564,
	"./CHICKADEE-v2.7.json": 1083,
	"./COMFORT-VIVID-v3.1.json": 1840,
	"./COMFORT-VIVID-v4.3.json": 8717,
	"./HARMONY-v0.3.json": 3600,
	"./HARMONY-v0.4.json": 904,
	"./HARMONY-v0.6.json": 8978,
	"./Industrial-Transceiver-1wire-v1.11.json": 7763,
	"./Industrial-Transceiver-v2.1.json": 616,
	"./KIWI-CLOVER-v2.0.json": 707,
	"./MEMO-(demo).json": 8080,
	"./ORCA-v0.14.json": 4666,
	"./ORCA-v1.0.json": 2918,
	"./ROBIN-FINCH-v1.0.json": 408,
	"./SEAL-v2.1.json": 7055,
	"./SEAL-v2.2.json": 9635,
	"./SPARROW-PELICAN-v2.8.json": 9215,
	"./SPARROW-PELICAN-v3.1.json": 5466,
	"./STORK-v2.0.json": 671,
	"./STORK-v2.1.json": 4691,
	"./STORK-v2.2.json": 2529,
	"./TUNDRA-v2.3.json": 2884,
	"./eBeat-v1.0.json": 7334,
	"./eBeat-v1.2.json": 3258,
	"./eBeat-v1.x.json": 270,
	"./eDoctor-v0.15.json": 5633,
	"./eDoctor-v1.2.json": 7435,
	"./eDoctor-v1.json": 5695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1321;